import { Theme } from '@emotion/react';
import React from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';

import { FoldButton } from '../category/fold-button';
import { useGlobalState, useSessionState } from '../global-state';
import { mediaQueries } from '../theme/mediaQueries';
import { CartItemComponent } from './cart-item';

export const CartManager: React.FC = () => {
  const { tICU } = useTranslations();
  const globalState = useGlobalState();
  const session = useSessionState();

  const [folded, setFolded] = React.useState<boolean>(true);

  if (
    !session.cart.items ||
    // @ts-ignore TODO: prepare for single cart force display cart
    (globalState.sessions.length === 1 && !session.flags.display_cart)
  ) {
    return null;
  }

  const visibleItems = folded ? session.cart.items.slice(0, 2) : session.cart.items;

  const elements = visibleItems.map((item, idx) => <CartItemComponent key={idx} cartItem={item} />);

  return (
    <div css={styles.wrapper}>
      <div css={styles.listWrapper}>{elements}</div>
      {session.cart.items.length > 2 && (
        <div>
          <FoldButton
            css={styles.foldButton}
            folded={folded}
            foldedText={tICU('widget.cart.VIEW_ALL')}
            unfoldedText={tICU('widget.cart.VIEW_LESS')}
            onClick={() => setFolded(oldFolded => !oldFolded)}
          />
        </div>
      )}
    </div>
  );
};

const styles = {
  wrapper: (theme: Theme) => ({
    borderTop: `1px solid ${theme.neutral90}`,
    padding: '20px 0',
  }),
  listWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '20px',
    [mediaQueries.S]: {
      gridTemplateColumns: '1fr',
    },
  },
  foldButton: {
    paddingTop: '20px',
  },
};
